import { LoadingOutlined } from "@ant-design/icons"

const LoadingModal = ({ className, loaderColor="orange" }) => {
  return (
    <div className={`fixed top-0 left-0 flex justify-center items-center w-screen h-screen bg-gray-200 ${className} z-[9999999]`}>
      <LoadingOutlined style={{ fontSize: 30, color: loaderColor }} />
    </div>
  )
}

export default LoadingModal
